var toastCount = 0;

function toast(content, time) {
	var time = time || 3000;

	toastCount = toastCount + 1;
	$('.toast').append('<div class="toast__message m' + toastCount + '">' + content + '</div>');

	setTimeout(removeToast, time, toastCount);
}

function removeToast(tc) {
	$('.m' + tc).remove();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/tools-panel/tools-panel.js
 **/